import VestingDetailsCard from "./VestingDetailsCard";

export default VestingDetailsCard;
